export default __webpack_public_path__ + "static/media/more.00f3534e.svg";